import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@modules/auth/services/auth.service';
import { catchError, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (req.headers.get('No-Auth') === 'true') {
    return next(req);
  }

  if (req.url.includes('/connect/token')) {
    return next(req);
  }

  let token = localStorage.getItem('userToken');

  if (authService.isTokenExpiringSoon(5) || !token) {
    return authService.refreshToken().pipe(
      switchMap(() => {
        const newToken = localStorage.getItem('userToken');
        const newAuthReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${newToken}`,
            'Content-Type': 'application/json'
          }
        });
        return next(newAuthReq);
      }),
    );
  }

  token = localStorage.getItem('userToken');

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });


  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        localStorage.removeItem('userToken');
        router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};